(function () {
  'use strict';

  /*
   * Belt-and-suspenders guard: card-product.liquid now only loads this
   * script once per page (via the {% increment %} guard). This check is
   * a second safety net in case the tag ever gets injected twice anyway
   * (e.g. AJAX-loaded grids like infinite scroll or predictive search
   * re-inserting card markup+script outside the normal page render).
   * Without it, a second execution would attach a second click listener
   * to document, and every heart click would toggle twice = net no-op.
   */
  if (window.__sawaaroWishlistInitialized) return;
  window.__sawaaroWishlistInitialized = true;

  var STORAGE_KEY = 'sawaaro_wishlist';

  function getWishlist() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      var list = saved ? JSON.parse(saved) : [];

      return Array.isArray(list) ? list.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isWishlisted(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function updateButton(button, active) {
    if (!button) return;

    button.classList.toggle('is-active', active);

    button.setAttribute(
      'aria-label',
      active ? 'Remove from wishlist' : 'Add to wishlist'
    );

    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function updateAllWishlistButtons() {
    var list = getWishlist();

    document
      .querySelectorAll('[data-sawaaro-wishlist][data-product-id]')
      .forEach(function (button) {
        var productId = String(
          button.getAttribute('data-product-id')
        );

        updateButton(
          button,
          list.indexOf(productId) !== -1
        );
      });
  }

  function updateWishlistCount() {
    var count = getWishlist().length;

    document
      .querySelectorAll('[data-sawaaro-wishlist-count]')
      .forEach(function (badge) {
        badge.textContent = count;

        badge.hidden = count === 0;
        badge.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      });

    document
      .querySelectorAll('[data-sawaaro-wishlist-count-text]')
      .forEach(function (element) {
        element.textContent = count;
      });
  }

  function updateWishlistHeader() {
    var count = getWishlist().length;

    document
      .querySelectorAll('.sw-header-wishlist')
      .forEach(function (headerButton) {
        headerButton.classList.toggle(
          'is-active',
          count > 0
        );
      });
  }

  function refreshWishlistUI() {
    updateAllWishlistButtons();
    updateWishlistCount();
    updateWishlistHeader();
  }

  function toggleWishlist(productId) {
    productId = String(productId);

    var list = getWishlist();
    var index = list.indexOf(productId);

    if (index === -1) {
      list.push(productId);
    } else {
      list.splice(index, 1);
    }

    saveWishlist(list);

    refreshWishlistUI();

    /*
     * Custom event allows other Sawaaro components
     * to react to wishlist changes.
     */
    document.dispatchEvent(
      new CustomEvent('sawaaro:wishlist:updated', {
        detail: {
          productId: productId,
          wishlist: list
        }
      })
    );
  }

  document.addEventListener('click', function (event) {

    /*
     * Wishlist buttons only.
     * This prevents the product-card link from opening
     * when the heart is clicked.
     */
    var button = event.target.closest(
      '[data-sawaaro-wishlist][data-product-id]'
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var productId = button.getAttribute('data-product-id');

    if (!productId) return;

    toggleWishlist(productId);
  });

  /*
   * Refresh when DOM is ready.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      refreshWishlistUI
    );
  } else {
    refreshWishlistUI();
  }

  /*
   * Keep multiple browser tabs/windows synchronized.
   */
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      refreshWishlistUI();
    }
  });

  /*
   * Expose a small public API for other Sawaaro scripts.
   */
  window.SawaaroWishlist = {
    get: getWishlist,
    has: isWishlisted,
    add: function (productId) {
      productId = String(productId);

      var list = getWishlist();

      if (list.indexOf(productId) === -1) {
        list.push(productId);
        saveWishlist(list);
        refreshWishlistUI();
      }
    },
    remove: function (productId) {
      productId = String(productId);

      var list = getWishlist();
      var index = list.indexOf(productId);

      if (index !== -1) {
        list.splice(index, 1);
        saveWishlist(list);
        refreshWishlistUI();
      }
    },
    toggle: toggleWishlist,
    refresh: refreshWishlistUI
  };

})();